/*
 * OAuth Callback Handler
 * 
 * Handles OAuth callbacks from Google and Facebook
 * Extracts authorization code and posts it back to parent window
 */

import React, { useEffect } from 'react';

const OAuthCallback = ({ provider }) => {
  useEffect(() => {
    const handleCallback = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const error = urlParams.get('error');
      const errorDescription = urlParams.get('error_description');
      
      if (error) {
        // Send error to parent window
        window.opener?.postMessage({
          provider,
          error: errorDescription || error
        }, window.location.origin);
      } else if (code) {
        // Send code to parent window
        window.opener?.postMessage({
          provider,
          code
        }, window.location.origin);
      }
      
      // Close popup
      window.close();
    };
    
    handleCallback();
  }, [provider]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="text-4xl mb-4">
          {provider === 'google' ? '🔍' : '📘'}
        </div>
        <p className="text-gray-600">
          Processing {provider === 'google' ? 'Google' : 'Facebook'} authentication...
        </p>
        <p className="text-sm text-gray-500 mt-2">
          This window will close automatically.
        </p>
      </div>
    </div>
  );
};

export default OAuthCallback;